import React, { useContext, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { TextInput, useTranslate, useNotify, BooleanInput, NumberInput } from 'react-admin'
import { Box, Button } from '@mui/material'
import { isInCheckedBoxList } from './helper'
import { CheckboxContext } from 'src/components/pages/sales/business-rule/logic/CheckboxContext'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'
import { LIQUIDATION, PRICE } from '../helper/const'

export const CreateCustomVar = ({ selectedRuleType, ruleLiquidationTypes }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const { watch, setValue, resetField, ...a } = useFormContext()
  const { checkedBox, setCheckedBox } = useContext(CheckboxContext)
  const key = watch('varCustomKey')
  const value = watch('varCustomValue')
  const description = watch('varCustomDescription')
  const show = watch('varCustomShow')
  const showSitio = watch('varCustomShowSitio')
  const ruleLiquidationType = watch('varRuleLiquidationType')

  useEffect(() => {
    if (!show || selectedRuleType !== LIQUIDATION || !ruleLiquidationTypes || ruleLiquidationTypes.length === 0) {
      resetField('varRuleLiquidationType')
    } else if (show && ruleLiquidationTypes && ruleLiquidationTypes.length === 1) {
      setValue('varRuleLiquidationType', [ruleLiquidationTypes[0].short_name])
    }
  }, [ruleLiquidationTypes])

  const onChangeShow = (e) => {
    const checked = e.target.checked
    if (checked && ruleLiquidationTypes && ruleLiquidationTypes.length === 1) {
      setValue('varRuleLiquidationType', [ruleLiquidationTypes[0].short_name])
    } else {
      resetField('varRuleLiquidationType')
    }
  }

  const isDisabledButton = () => {
    return !key ||
      (show && selectedRuleType === LIQUIDATION && (!ruleLiquidationType || ruleLiquidationType.length === 0))
  }

  const onSubmit = () => {
    const newChecked = [...checkedBox]
    if (!isInCheckedBoxList(checkedBox, key)) {
      let item = {
        key,
        value: value ? value : 0,
        label: key,
        show: show,
        show_sitio: showSitio ?? false,
        global_variable: false,
        description: description,
        search: ['var', key, 'value'],
        rule_liquidation_type: ruleLiquidationType,
        created: true,
      }
      newChecked.push(item)
      setCheckedBox(newChecked)
      resetField('varCustomKey')
      resetField('varCustomValue')
      resetField('varCustomDescription')
      resetField('varCustomShow')
      resetField('varCustomShowSitio')
      resetField('varRuleLiquidationType')
      return
    }
    notify('El nombre de la variable ya existe', { type: 'error' })
  }

  return (
    <Box>
      <Box>
        <EditInputsWrap label={translate('ra.field.name')} className='small' required>
          <TextInput fullWidth source='varCustomKey' label='' />
        </EditInputsWrap>
        <EditInputsWrap label={translate('ra.field.description')}>
          <TextInput fullWidth source='varCustomDescription' label='' multiline rows={5} />
        </EditInputsWrap>
        <Box sx={{ display: 'flex' }}>
          <EditInputsWrap label={translate('ra.field.value')} className='small'>
            <NumberInput fullWidth source='varCustomValue' label='' />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.show_breakdown')} className='small'>
            <BooleanInput fullWidth source='varCustomShow' label='' onChange={onChangeShow} />
          </EditInputsWrap>
          {selectedRuleType === PRICE && (
            <EditInputsWrap label={translate('ra.field.show_sitio')} className='small'>
              <BooleanInput fullWidth source='varCustomShowSitio' label='' />
            </EditInputsWrap>
          )}
        </Box>
       {show && selectedRuleType === LIQUIDATION && (
          <EditInputsWrap label={translate('ra.field.rule_type')} className='small' required>
            <SelectInput
              source='varRuleLiquidationType'
              options={ruleLiquidationTypes ?? []}
              label=''
              multiple
              optionValue='short_name'
              optionsText={['long_name']}
              helperText={' '}
              disabled={ruleLiquidationTypes.length === 1}
            />
          </EditInputsWrap>
        )}
      </Box>

      <Button
        disabled={isDisabledButton()}
        onClick={onSubmit}
        style={{ height: '30px' }}
        size='small'
        variant='contained'
      >
        {translate('ra.action.create')}
      </Button>
    </Box>
  )
}
